import { render, staticRenderFns } from "./KBSourcesExplorer.vue?vue&type=template&id=5ba4fb50&scoped=true&lang=pug"
import script from "./KBSourcesExplorer.vue?vue&type=script&lang=js"
export * from "./KBSourcesExplorer.vue?vue&type=script&lang=js"
import style0 from "./KBSourcesExplorer.vue?vue&type=style&index=0&id=5ba4fb50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4fb50",
  null
  
)

export default component.exports